import useReports from './useReports'

export default (month: string) => {
  const reports = useReports()
  return reports[month]
}
